<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.replenishmentRule')" type="confirm" width="40%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="rule" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.replenishSourceStorageRoom')" prop="sourceStorageRoom">
            <vxe-input v-model="rule.sourceStorageRoom.name" style="width: 100%" @clear="onInputChange(rule,'sourceStorageRoom')" @click="onStorageRoomSelect"/>
          </a-form-model-item>
          <storage-room-modal ref="storageRoomModal" @change="(values)=>onInputChange(rule,'sourceStorageRoom',values[0])"/>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.obtainTimes')" prop="times">
            <vxe-number-input v-model="rule.times" :max="2" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.handover')" :wrapper-col="labelCol">
            <vxe-switch v-model="rule.handover"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.transmissionType')" prop="transmissionType">
            <vxe-select v-model="rule.transmissionType" :options="transmissionTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { save } from '@/api/Api'
import { ReplenishmentRule } from '@/api/dto/config/ReplenishmentRule'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  name: 'ReplenishmentRuleEditor',
  components: { StorageRoomModal },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      visible: false,
      loading: false,
      rule: new ReplenishmentRule(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        'sourceStorageRoom': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'times': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'transmissionType': [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    transmissionTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    onInputChange,
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, storageRoomType: 1 })
    },
    add(storageRoom) {
      this.visible = true
      this.rule = new ReplenishmentRule()
      this.rule.targetStorageRoom = new StorageRoom(storageRoom)
    },
    edit(row, copy) {
      this.visible = true
      if (copy) {
        row.id = undefined
        row.version = undefined
      }
      this.rule = new ReplenishmentRule(row)
    },
    save() {
      this.loading = true
      const rule = this.rule.toJSONObject()
      rule.warehouse = this.warehouse
      save('replenishmentRulePersister', rule).then(res => {
        if (res.success) {
          this.$emit('success')
          this.$message.success(this.$t('message.saveSuccess'))
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>